import { GenData, QSingle } from '@educraft/base';
import { SimpleGenSingle } from '../../genEq/genHelper';
import { Numerals } from '../../core/numerals';

export const Mat_Numbers_English_Addition_To100_Base = {
  addition:
    () =>
    (data: GenData): QSingle => {
      const r = data.random;
      const a = r.next(1, 99);
      const b = r.next(1, 100 - a);
      const sum = a + b;

      const text = `${Numerals.toEnglishString(a)} plus ${Numerals.toEnglishString(b)}`;
      const answer = Numerals.toEnglishString(sum);

      return { texts: [text], answer };
    },
};

export class Math_Numbers_English__Addition_To100 extends SimpleGenSingle {
  constructor() {
    super(
      Mat_Numbers_English_Addition_To100_Base.addition(),
      'Math_Numbers_English__Addition_To100'
    );
  }
}
